/*
 * @Descripttion:
 * @version:
 * @Author: afeng510
 * @Date: 2021-08-11 20:35:52
 * @LastEditors: afeng510
 * @LastEditTime: 2021-08-26 16:54:52
 */
module.exports = {

  title: '浮云海鲜',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
}
